var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboardGoogleCloudIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2157_23048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6649 4.48615L13.2906 4.49531L14.9909 2.79506L15.0733 2.07467C13.7241 0.875038 11.9445 0.142437 9.99698 0.142437C6.47439 0.142437 3.50125 2.53865 2.62213 5.78652C2.80833 5.65831 3.20516 5.75294 3.20516 5.75294L6.6026 5.19433C6.6026 5.19433 6.77659 4.90434 6.86511 4.9196C7.66792 4.03743 8.8065 3.53377 10 3.53377C11.0074 3.53377 11.9353 3.89091 12.6649 4.48004V4.48615Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3779 5.7927C16.9841 4.33666 16.1691 3.05155 15.0702 2.07475L12.6618 4.48318C13.6264 5.26157 14.246 6.45204 14.246 7.78599V8.21028C15.4182 8.21028 16.3675 9.16267 16.3675 10.3318C16.3675 11.5009 15.4152 12.4533 14.246 12.4533H10L9.57571 12.8806V15.4295L10 15.8507H14.246C17.2924 15.8476 19.7619 13.3782 19.765 10.3318C19.765 8.45448 18.8187 6.79087 17.3749 5.78965L17.3779 5.7927Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75091 15.8568H9.99389V12.4563H5.75091C5.44871 12.4563 5.15262 12.3922 4.87789 12.267L4.26434 12.4563L2.56409 14.1565L2.41452 14.7304C3.37301 15.46 4.54517 15.8568 5.75091 15.8568Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75092 4.8158C2.70452 4.81885 0.235047 7.28833 0.231995 10.3347C0.231995 12.1265 1.08975 13.723 2.42064 14.7303L4.88096 12.27C4.12088 11.9281 3.62943 11.1711 3.62943 10.3347C3.62943 9.16256 4.58181 8.21324 5.75092 8.21324C6.61173 8.21324 7.35043 8.73216 7.68621 9.46476L10.1465 7.00444C9.13615 5.67661 7.54274 4.8158 5.75092 4.8158Z",
    fill: "#FBBC05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2157_23048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.536,
    height: 15.7143,
    fill: "white",
    transform: "translate(0.231964 0.142647)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardGoogleCloudIcon);
export default __webpack_public_path__ + "static/media/onboard-google-cloud-icon.204e4e75513b41a3c5962d99338c8b25.svg";
export { ForwardRef as ReactComponent };